import {
  setShowSystemKeys,
} from '../../facts/table-view';

require('./chat-viewer.component.scss');

class ChatViewerController {
  constructor(
    $scope,
    $window,
    $element,
    $timeout,
    RouterService,
    CurrentModelService,
    CurrentFilterService,
    ErrorHandlerService,
    AggregateDataService,
    LayoutService,
  ) {
    this.router = RouterService;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterService = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.AggregateDataService = AggregateDataService;
    this.typeDim = 'agent_eventtype@default:agent_eventtype';
    this.$element = $element;
    this.previousTop = -1;
    this.dialogBody = this.$element.context.querySelector('.dialog-body');
    this.filterData = this.router.CurrentFilterDataService.filterData;
    this._data = [];
    this.isSuitFilter = true;
    this.needToScroll = false;
    this.headData = {
      canChange: true,
      membersDim: 'agent_dialog@members:members',
      channelDim: 'agent_dialog@dialog_type:dialog_type',
      userDim: 'agent_account@user_name:user_name',
      length: 0,
    };
    this.doOnScroll = true;

    this.subscription = this.filterData.filterData$
      .subscribe(() => {
        this.setSuitFilter();
        if (!this.data || !this.data.length) return;
        if (this.previousTop === -1) this.previousTop = this.dialogBody.scrollTop;
        this.resortData();
      });

    $scope.$on('$destroy', () => this.subscription.dispose());

    $scope.$on('dimensionToggle', () => {
      this.setSuitFilter();
    });

    $scope.$on('aggregare-loaded', () => {
      this.setSuitFilter();
      // this.setFilters();
    });

    $scope.$watch('$ctrl.curFilter.listType', () => {
      if (this.filter.listType === 'chat-viewer') this.setFilters();
    });

    this.$timeout(() => this.resortData(), 10);
    setShowSystemKeys(LayoutService.options);
  }

  get data() {
    return this._data;
  }

  set data(data) {
    this._data = data;
  }

  resortData() {
    if (!this.data) return;
    const fVal = fact => {
      const date = new Date(fact['local_time']);
      return {
        id: +fact['id'],
        t: date.valueOf() + date.getTimezoneOffset() * 60000,
        u: fact['agent_account.user_name'],
        m: fact['agent_dialog.members'],
      };
    };

    this.data = this.data.sort((aFact, bFact) => {
      const a = fVal(aFact);
      const b = fVal(bFact);

      if (a.u === b.u) {
        if (a.m === b.m) {
          if (a.t === b.t) return a.id - b.id;
          else return a.t - b.t;
        } else {
          return a.m > b.m ? 1 : -1;
        }
      } else {
        return a.u > b.u ? 1 : -1;
      }
    });

    this.headData.length = this.data.length;
    this.needToScroll = true;
  }

  scrollToFCurrectFact(isLast) {
    if (this.CurrentFilterService.filter.isCardOrDashboard) return true;
    if (!isLast || !this.needToScroll) return true;
    this.needToScroll = false;
    this.$timeout(() => {
      if (!this.data) return true;
      if (this.headData.id == undefined) this.headData.id = this.data[this.data.length - 1].id;
      else this.headData.canChange = false;

      const el = this.$element.find('#' + this.headData.id);
      if (!el || !el[0]) return;
      el[0].scrollIntoView();
      this.$timeout(() => {
        if (!this.headData.user) this.onScroll();
        this.headData.canChange = true;
      }, 200);
    }, 200);
    return true;
  }


  getCurrentFact() {
    const curMessagePos = this.dialogBody.scrollTop + 20;
    const nodes = this.dialogBody.children;
    let prevEl = null;
    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];
      const pos = el.children[0].offsetTop - curMessagePos;
      if (pos >= 0) {
        let id = 0;
        if (pos < 200) id = el.id;
        else id = prevEl.id;
        return this.data.find(d => {
          return d.id == id;
        });
      }
      prevEl = el;
    }
    return this.data && this.data[0];
  }

  setFilterCut(dim, val) {
    this.curFilter.cleanFilter(dim);
    this.curFilter.addFilter(dim, val, val);
    this.router.filterChanged();
  }

  hasAccounts(accountKey) {
    return this.headData.fact.accounts && this.headData.fact.accounts[accountKey];
  }

  setDialogHead(fact) {
    if (!this.headData.canChange) return;
    this.headData.id = fact.id;
    this.headData.userName = fact['agent_account.user_name'];
    this.headData.userFullName = fact['agent_account.full_name'];
    this.headData.user = this.headData.userFullName ? this.headData.userFullName : this.headData.userName;
    this.headData.members = fact['agent_dialog.members'];
    this.headData.membersArr = this.headData.members ? Array.from(new Set(this.headData.members.split(' '))) : [];
    // console.log(this.headData.membersArr);
    this.headData.fact = fact;
    this.headData.channel = fact['agent_dialog.dialog_type'];
    this.headData.length = this.data ? this.data.length : this.filterData.filterData.length;

  }

  onScroll(e) {
    if (!this.doOnScroll) return;
    this.doOnScroll = false;
    this.$timeout(() => {

      const fact = this.getCurrentFact();
      if (fact) {
        this.setDialogHead(fact);
      }
      // console.log('scrollTop: ', this.dialogBody.scrollTop, this.dialogBody.scrollHeight, this.dialogBody.scrollTop / this.dialogBody.scrollHeight * 100);
      if (this.headData.canChange && this.previousTop < this.dialogBody.scrollTop &&
         (this.dialogBody.scrollHeight - this.dialogBody.scrollTop) / this.dialogBody.scrollHeight * 100 < 5) {
        this.more();
      }
      this.previousTop = this.dialogBody.scrollTop;
      this.doOnScroll = true;
    }, 200);

  }

  showHead(i) {
    const headData = fact => ({
      user: fact['agent_account.user_name'],
      channel: fact['agent_dialog.dialog_type'],
      members: fact['agent_dialog.members'],
    });
    if (i === 0) return true;
    return !angular.equals(headData(this.data[i - 1]), headData(this.data[i]));
  }

  get isLoading() {
    const loading = this.CurrentModelService.loading ||
      this.filterData.loading ||
      this.filterData.loadingMore ||
      this.AggregateDataService.loading ||
      this.AggregateDataService.loadingMore;
    return loading;
  }

  more(e) {
    if (this.isLoading) return null;
    return this.filterData.moreFacts();
  }

  openImage(fact) {
    const url = 'media/' + fact['agent_attachedfile.data'];
    // console.log( url);
    this.$window.open(url);
  }

  get curFilter() {
    if (this.router.isFilterEditModal) return this.filter;
    return  this.filter ? this.filter : this.CurrentFilterService.filter;
  }

  get participants() {
    const dim = this.curFilter.filters.find(f => f.dimension === this.threadDim);
    return dim ? dim.label : '';
  }

  get firstFact() {
    if (!this.data || !this.data.length) return {
      userId: 0,
      userName: '',
      channel: '',
    };
    const f1 = this.data[0];
    return {
      userId: f1['agent_account.id'],
      userName: f1['agent_account.user_name'],
      channel: f1['agent_dialog.dialog_type']
    };
  }

  setSuitFilter() {
    let typeCount = 0;
    this.isSuitFilter = this.curFilter.filters.length &&
      this.curFilter.filters.every(f => {
        const goodType = f.dimension === this.typeDim && (f.value === '8' || f.value === '9');
        if (goodType) typeCount += 1;
        return f.dimension !== this.typeDim || goodType;
      }) && !!typeCount;

    return this.isSuitFilter;
  }

  setFilters() {
    this.isSuitFilter = true;
    this.headData.length = 0;
    let typeCount = 0;
    this.curFilter.filters = this.curFilter.filters.filter(f => {
      const goodType = f.dimension === this.typeDim &&
        (f.value === '8' || f.value === '9');
      if (goodType) typeCount += 1;
      return goodType || f.dimension !== this.typeDim;
    });
    if (!typeCount) {
      this.curFilter.cleanFilter('agent_eventtype@default:agent_eventtype');
      this.curFilter.addFilter('agent_eventtype@default:agent_eventtype', '8', gettext('Интернет-пейджер'));
      this.curFilter.addFilter('agent_eventtype@default:agent_eventtype', '9', gettext('Почта'));
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.router.filterChanged();
    }
  }
}


export const ChatViewerComponent = {
  template: require('./chat-viewer.component.html'),
  bindings: {
    model: '<',
    data: '<',
    filter: '<',
    filterData: '<',
  },
  controller: ChatViewerController,
};



// WEBPACK FOOTER //
// ./src/view/chat-viewer/chat-viewer.component.js